import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7e161749")
const _hoisted_1 = { class: "topbar clearfix" }
const _hoisted_2 = { class: "topbar-left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "topbar-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "p-link" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: "profile-image pi pi-user",
  style: {"display":"grid","place-items":"center","color":"white"}
}, null, -1)
const _hoisted_11 = { class: "topbar-item-name" }
const _hoisted_12 = { class: "topbar-item-role" }
const _hoisted_13 = {
  id: "topbar-profile-menu",
  class: "layout-menu fadeInDown"
}
const _hoisted_14 = { role: "menuitem" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", { class: "p-link topbar-item-button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-user" }),
  /*#__PURE__*/_createElementVNode("span", null, "Profile")
], -1)
const _hoisted_16 = { role: "menuitem" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-sign-out" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Logout", -1)
const _hoisted_19 = { class: "p-link" }
const _hoisted_20 = {
  id: "topbar-notifications-menu",
  class: "layout-menu fadeInDown"
}
const _hoisted_21 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_22 = { class: "read-all clearfix" }
const _hoisted_23 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TopBarMessages = _resolveComponent("TopBarMessages")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: {name: 'HOME'} }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            alt: "Logo",
            src: '/assets/layout/images/' + _ctx.logo,
            class: "topbar-logo"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "p-link",
        id: "menu-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuButtonClick && _ctx.onMenuButtonClick(...args)))
      }, _hoisted_6),
      _createElementVNode("button", {
        class: "p-link",
        id: "topbar-menu-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTopbarMenuButtonClick && _ctx.onTopbarMenuButtonClick(...args)))
      }, _hoisted_8),
      _createElementVNode("ul", {
        class: _normalizeClass(_ctx.topbarItemsClass)
      }, [
        (_ctx.profileMode === 'top' || _ctx.horizontal)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass(['profile-item', {'active-top-menu': _ctx.activeTopbarItem === 'profile'}]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('topbar-item-click',{originalEvent:$event,item:'profile'})))
            }, [
              _createElementVNode("button", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userName), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.userRole), 1)
              ]),
              _createVNode(_Transition, { name: "layout-submenu-container" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("ul", _hoisted_13, [
                    _createElementVNode("li", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: _ctx.profileRoute,
                        style: {"margin":"0","padding":"0","border":"0"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.logOut,
                        to: _ctx.loginRoute,
                        class: "p-link topbar-item-button"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["onClick", "to"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.activeTopbarItem === 'profile']
                  ])
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true),
        ((_ctx.profileMode === 'top' || _ctx.horizontal) && _ctx.canSeeMessages)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              class: _normalizeClass(['notification-item p-mr-2', {'active-top-menu': _ctx.activeTopbarItem === 'notifications'}]),
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openNotificationsBox && _ctx.openNotificationsBox(...args)))
            }, [
              _createElementVNode("button", _hoisted_19, [
                _createVNode(_component_TopBarMessages, {
                  onOnEvent: _ctx.onPusherEvent,
                  onOnCountChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.notifications.notReadCount = $event))
                }, null, 8, ["onOnEvent"])
              ]),
              _createVNode(_Transition, { name: "layout-submenu-container" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("ul", _hoisted_20, [
                    (_ctx.requestPending || _ctx.loadingPusher)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                          _createVNode(_component_ProgressSpinner)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.requestPending && !_ctx.loadingPusher)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("li", _hoisted_22, [
                            (_ctx.notifications.notReadCount)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  type: "button",
                                  label: "Read all",
                                  disabled: _ctx.loadingPusher,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.readAll()))
                                }, null, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications.list, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              onClick: ($event: any) => (_ctx.goToDetails(item)),
                              class: _normalizeClass(["notification-items", { 'is-read' : item.is_read,}]),
                              key: item.id,
                              role: "menuitem"
                            }, [
                              _createElementVNode("p", null, [
                                _createTextVNode(_toDisplayString(item.message), 1),
                                _createElementVNode("span", null, _toDisplayString(item.fromNow), 1)
                              ])
                            ], 10, _hoisted_23))
                          }), 128)),
                          (_ctx.canLoadMore)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMore())),
                                role: "menuitem",
                                class: "load-more"
                              }, " Load More "))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, _ctx.activeTopbarItem === 'notifications']
                  ])
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}